import { render, staticRenderFns } from "./manage-activation-policy.vue?vue&type=template&id=0ec2566c&scoped=true&"
import script from "./manage-activation-policy.vue?vue&type=script&lang=js&"
export * from "./manage-activation-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2566c",
  null
  
)

export default component.exports